import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Preorder } from 'autogen/translation-keys/trans-website-shared-buttons';
import { Button, ButtonWithIcon } from 'components/Button';
import Icon from 'components/Icon';
import NotificationForm from 'components/product/notification';
import QuickView, { useQuickView } from 'components/quickView';
import { breakpoint, sizes } from 'variables';
import type { ProductActionProps } from '../../shared/types';

const StyledQuickView = styled(QuickView)`
    // && for specificity
    && {
        ${breakpoint.up(sizes.md)} {
            min-width: 480px;
            width: 480px;
        }
    }
`;

export function PreorderButton({ params, trackingInfo, children, ...restProps }: ProductActionProps['Preorder']) {
    const { t } = useTranslation();
    const { toggle } = useQuickView('NotificationForm');
    const [loadQuickView, setLoadQuickView] = useState(false);
    const { customerNotification } = params;

    return (
        <>
            <Button
                onClick={() => {
                    setLoadQuickView(true);
                    toggle(true);
                }}
                variant="secondary"
                type="button"
                {...restProps}
            >
                {children || t(Preorder)}
            </Button>

            {loadQuickView && customerNotification && (
                <StyledQuickView quickViewId="NotificationForm" onClose={() => setLoadQuickView(false)}>
                    <NotificationForm model={customerNotification} />
                </StyledQuickView>
            )}
        </>
    );
}

export function PreorderButtonCompact({ params, ...restProps }: ProductActionProps['Preorder']) {
    const { toggle } = useQuickView('NotificationForm');
    const [loadQuickView, setLoadQuickView] = useState(false);
    const { t } = useTranslation();
    const { customerNotification } = params;

    return (
        <>
            <ButtonWithIcon
                icon={<Icon type="ChevronRight" size={16} />}
                onClick={() => {
                    setLoadQuickView(true);
                    toggle(true);
                }}
                variant="secondary"
                type="button"
                aria-label={t(Preorder)}
                {...restProps}
            />

            {loadQuickView && customerNotification && (
                <StyledQuickView quickViewId="NotificationForm" onClose={() => setLoadQuickView(false)}>
                    <NotificationForm model={customerNotification} />
                </StyledQuickView>
            )}
        </>
    );
}

export default Object.assign(PreorderButton, {
    Compact: PreorderButtonCompact
});
